/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindBiddersResponseDto } from '../../models/find-bidders-response-dto';

export interface FindBidders$Params {
  auc_id?: number;
  user_id?: number;
  inumis_id?: number;
  number?: number;
  s?: string;
  primary?: boolean;
  '$sortby': string;
  '$sortdir': string;
  '$page'?: number;
  '$maxpagesize': number;
  '$goto_num'?: number;
  includeRelatedUsers?: boolean;
  'X-API-Version'?: string;
}

export function findBidders(http: HttpClient, rootUrl: string, params: FindBidders$Params, context?: HttpContext): Observable<StrictHttpResponse<FindBiddersResponseDto>> {
  const rb = new RequestBuilder(rootUrl, findBidders.PATH, 'get');
  if (params) {
    rb.query('auc_id', params.auc_id, {});
    rb.query('user_id', params.user_id, {});
    rb.query('inumis_id', params.inumis_id, {});
    rb.query('number', params.number, {});
    rb.query('s', params.s, {});
    rb.query('primary', params.primary, {});
    rb.query('$sortby', params['$sortby'], {});
    rb.query('$sortdir', params['$sortdir'], {});
    rb.query('$page', params['$page'], {});
    rb.query('$maxpagesize', params['$maxpagesize'], {});
    rb.query('$goto_num', params['$goto_num'], {});
    rb.query('includeRelatedUsers', params.includeRelatedUsers, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindBiddersResponseDto>;
    })
  );
}

findBidders.PATH = '/api/bidders';
